<div *ngIf="fieldDefinitionFound">
    <strong style="margin-bottom: 10px;">{{fieldDefinition.ColumnLabel}}</strong><br />
    <span *ngIf="showDisplayNoLink">{{displayValue}}</span>
    <span *ngIf="showDisplayLink && displayValue != null"><a href="{{displayValue}}" target="_blank">{{displayValue}}</a></span>
    <br *ngIf="showDisplayNoLink && (displayValue === null || displayValue === '')" />
    <div *ngIf="showInput" style="margin-top: 5px; margin-bottom: 10px">
        <!-- text input -->
        <input type="text"
               class="form-control"
               *ngIf="controlType['string']"
               [required]="fieldDefinition.Required"
               [name]="fieldDefinition.ColumnName"
               [attr.maxLength]="fieldDefinition.Length === -1 ? null : fieldDefinition.Length"
               [disabled]="disabled"
               (blur)="onFieldBlur()"
               [(ngModel)]="controlValue" />
        <!-- web input -->
        <input type="text"
               class="form-control"
               *ngIf="controlType['web']"
               [required]="fieldDefinition.Required"
               [name]="fieldDefinition.ColumnName"
               [attr.maxLength]="fieldDefinition.Length === -1 ? null : fieldDefinition.Length"
               [disabled]="disabled"
               (blur)="onFieldBlur()"
               [(ngModel)]="controlValue"
               appUrlValidate />
        <!-- decimal input -->
        <input type="text"
               class="form-control"
               *ngIf="controlType['decimal']"
               [(ngModel)]="controlValue"
               [required]="fieldDefinition.Required"
               [name]="fieldDefinition.ColumnName"
               [disabled]="disabled"
               (blur)="onFieldBlur()"
               appDecimalLengthValidate [leftLength]="fieldDefinition.DecimalCharsLeft" [rightLength]="fieldDefinition.DecimalCharsRight"
               appNumericValidate />
        <!-- whole number input -->
        <input type="text"
               class="form-control"
               *ngIf="controlType['wholenumber']"
               [(ngModel)]="controlValue"
               [required]="fieldDefinition.Required"
               [name]="fieldDefinition.ColumnName"
               [disabled]="disabled"
               (blur)="onFieldBlur()"
               [appNumericRangeByTypeValidate]="this.fieldDefinition.Type"
               appWholeNumberValidate />
        <!-- percent input -->
        <input type="text"
               class="form-control"
               *ngIf="controlType['percent']"
               [(ngModel)]="controlValue"
               [required]="fieldDefinition.Required"
               [name]="fieldDefinition.ColumnName"
               [disabled]="disabled"
               (blur)="onFieldBlur()"
               appDecimalLengthValidate [leftLength]="fieldDefinition.DecimalCharsLeft" [rightLength]="fieldDefinition.DecimalCharsRight"
               appNumericValidate />
        <!-- checkbox -->
        <input type="checkbox"
               *ngIf="controlType['checkbox']"
               [(ngModel)]="controlValue"
               style="width:30px;height:30px;display:block;"
               [disabled]="disabled"
               [name]="fieldDefinition.ColumnName"
               (click)="onFieldBlur()"
               trueFalseValue trueValue="Y" falseValue="N" />
        <!-- textarea -->
        <textarea class="form-control"
                  [name]="fieldDefinition.ColumnName"
                  [attr.maxLength]="fieldDefinition.Length === -1 ? null : fieldDefinition.Length"
                  [(ngModel)]="controlValue"
                  *ngIf="controlType['notes']"
                  (blur)="onFieldBlur()"
                  [required]="fieldDefinition.Required"
                  [disabled]="disabled"></textarea>
        <!-- dropdown/combobox -->
        <select class="form-control"
                [(ngModel)]="controlValue"
                *ngIf="controlType['combobox']"
                [required]="fieldDefinition.Required"
                [name]="fieldDefinition.ColumnName"
                [disabled]="disabled"
                (ngModelChange)="onFieldBlur()">
            <option *ngFor="let data of fieldDefinition.ComboTypes"
                    [ngValue]="data.DatabaseValue">
                {{data.DisplayValue}}
            </option>
        </select>
        <!-- date -->
        <div class="input-group" *ngIf="controlType['date']">
            <input type="text"
                   class="form-control"
                   bsDatepicker #datedp="bsDatepicker"
                   [(ngModel)]="controlValue"
                   [outsideClick]="true"
                   [required]="fieldDefinition.Required"
                   [name]="fieldDefinition.ColumnName"
                   [ngClass.disableField]="disabled"
                   [bsConfig]="datePickerOptions"
                   style="background-color:#ffffff"
                   [disabled]="disabled"
                   (blur)="onFieldBlur()" />
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                        (click)="datedp.show()"
                        [attr.aria-expanded]="datedp.isOpen"
                        style="margin-right:0px; background-color: white;"
                        [disabled]="disabled">
                    <i class="oi oi-calendar"></i>
                </button>
            </div>
        </div>
        <!-- month -->
        <div class="input-group" *ngIf="controlType['month']">
            <input type="text" class="form-control"
                   bsDatepicker #monthdp="bsDatepicker"
                   [(ngModel)]="controlValue"
                   [outsideClick]="true"
                   [required]="fieldDefinition.Required"
                   [name]="fieldDefinition.ColumnName"
                   [ngClass.disableField]="disabled"
                   [bsConfig]="datePickerOptionsMonth"
                   style="background-color:#ffffff"
                   [disabled]="disabled"
                   (blur)="onFieldBlur()"
                   (onShown)="onOpenCalendar($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                        (click)="monthdp.show()"
                        [attr.aria-expanded]="monthdp.isOpen"
                        style="margin-right: 0px; background-color: white;"
                        [disabled]="disabled">
                    <i class="oi oi-calendar"></i>
                </button>
            </div>
        </div>
    </div>
</div>